<template>
  <!-- 左侧菜单 -->
  <el-drawer
    class="all-functions"
    :style="menuCollapseStyle"
    :visible.sync="drawerVisible"
    direction="ltr"
    :size="isUnderMobile() ? null : 1000"
    :show-close="false"
    @closed="_onClosed"
  >
    <!-- 标题 -->
    <!-- <div slot="title" class="lc-primary-color">
      <el-button icon="el-icon-close" class="close-button" type="text" @click="_onClosed"></el-button>
      全部功能
    </div> -->

    <!-- 操作 -->
    <div class="toolbar">
      <!-- 搜索 -->
      <div class="leftside">
        <el-input ref="searchTextInput" v-model="searchText" :placeholder="$t('menu.placeholder.input_search_text')">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>

      <div class="rightside">
        <!-- 切换主题 -->
        <el-button class="mobile-flex-item" icon="el-icon-x lc-ico-theme" @click="routerToAfterClosed('/themes')">
          {{ $t('menu.btn.switch_theme') }}</el-button
        >

        <!-- 下载手机端 -->
        <el-popover ref="download-mobile-version" class="mobile-flex-item" placement="top" width="230">
          <div>
            <vue-qr :text="ecmpSpAppStoreUrl" :margin="0" :size="200" :logo-scale="2" :scale="2" class="qrcode"></vue-qr>

            <div class="m-t-10">微信扫码</div>
            <div class="lc-secondary-color">公众号 和 安卓版已支持</div>
            <div class="lc-secondary-color">iOS 版本需联系技术现场安装</div>
          </div>
        </el-popover>
        <el-button v-popover:download-mobile-version icon="el-icon-mobile">{{ $t('menu.btn.download_mobile_version') }}</el-button>

        <!-- 版本 -->
        <el-popover ref="view-version" class="mobile-flex-item" placement="top" width="400">
          <div class="system-info-container">
            <div>
              <span class="lc-secondary-color m-r-5">{{ $t('menu.labels.browser') }}:</span> {{ systemInfo.browser_description }}
            </div>
            <div>
              <span class="lc-secondary-color m-r-5">{{ $t('menu.labels.ui_version') }}:</span> {{ systemInfo.ui_version }}
            </div>
            <div>
              <span class="lc-secondary-color m-r-5">{{ $t('menu.labels.ui_commit') }}:</span> {{ systemInfo.ui_commit }}
            </div>
            <div>
              <span class="lc-secondary-color m-r-5">{{ $t('menu.labels.api_version') }}:</span> {{ systemInfo.api_version }}
            </div>
            <div>
              <span class="lc-secondary-color m-r-5">{{ $t('menu.labels.api_commit') }}:</span> {{ systemInfo.api_commit }}
            </div>
          </div>
        </el-popover>
        <el-button v-popover:view-version @click="loadApiVersion">{{ $t('menu.btn.view_version') }} {{ systemInfo.ui_version }}</el-button>

        <!-- 关闭 -->
        <el-button class="mobile-flex-item" icon="el-icon-close" @click="_onClosed">{{ $t('menu.btn.close') }}</el-button>
      </div>
    </div>

    <!-- 功能清单 -->
    <el-row :gutter="10" style="margin: 0px 10px;">
      <el-col :span="isUnderMobile() ? 24 : 4">
        <!-- 工作台 -->
        <function :menu-item="menuItem('console')" :highline-text="searchText" @close-draw="_onClosed" />

        <!-- 站桩管理 -->
        <function :menu-item="menuItem('charging_pile_station')" :highline-text="searchText" @close-draw="_onClosed" />

        <!-- 车位停车 -->
        <function :menu-item="menuItem('parking')" :highline-text="searchText" @close-draw="_onClosed" />
      </el-col>

      <el-col :span="isUnderMobile() ? 24 : 4">
        <!-- 交易管理 -->
        <function :menu-item="menuItem('trade')" :highline-text="searchText" @close-draw="_onClosed" />

        <!-- 用户管理 -->
        <function :menu-item="menuItem('user')" :highline-text="searchText" @close-draw="_onClosed" />
      </el-col>

      <el-col :span="isUnderMobile() ? 24 : 4">
        <!-- 运营结算 -->
        <function :menu-item="menuItem('settlement')" :highline-text="searchText" @close-draw="_onClosed" />

        <!-- 工单管理 -->
        <function :menu-item="menuItem('application')" :highline-text="searchText" @close-draw="_onClosed" />

        <!-- 通知中心 -->
        <function :menu-item="menuItem('notification')" :highline-text="searchText" @close-draw="_onClosed" />
      </el-col>

      <el-col :span="isUnderMobile() ? 24 : 4">
        <!-- 报表 -->
        <function :menu-item="menuItem('report')" :highline-text="searchText" @close-draw="_onClosed" />

        <!-- 系统管理 -->
        <function :menu-item="menuItem('system')" :highline-text="searchText" @close-draw="_onClosed" />
      </el-col>

      <el-col :span="isUnderMobile() ? 24 : 4">
        <!-- 营销管理 -->
        <function :menu-item="menuItem('marketing')" :highline-text="searchText" @close-draw="_onClosed" />

        <!-- 商城管理 -->
        <function :menu-item="menuItem('store')" :highline-text="searchText" @close-draw="_onClosed" />
      </el-col>

      <el-col :span="isUnderMobile() ? 24 : 4">
        <!-- APP设置 -->
        <function :menu-item="menuItem('app_setting')" :highline-text="searchText" @close-draw="_onClosed" />

        <!-- 互联互通 -->
        <function :menu-item="menuItem('evcs')" :highline-text="searchText" @close-draw="_onClosed" />
      </el-col>
    </el-row>
  </el-drawer>
</template>

<script>
/*global platform */

import menuItems from '@/new_menu'
import Function from './components/Function'
import '@/libs/platform'
import systemApi from '@/api/system_api'
import VueQr from 'vue-qr'
import nativeMsgUtil from '@/utils/native_msg_util'

export default {
  components: { Function, VueQr },
  props: {
    // 是否展示
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drawerVisible: false,
      menuTree: menuItems,
      searchText: '',
      systemInfo: {
        ui_version: '1.0.0',
        ui_commit: '',
        api_version: '',
        api_commit: '',
        browser_description: ''
      },
      ecmpSpAppStoreUrl: process.env.VUE_APP_ECMP_SP_STORE
    }
  },
  computed: {
    /**
     * 菜单是否收起
     *
     * @returns {boolean} 是否收起
     */
    isMenuCollapse() {
      // 直接读取 state
      return this.$store.state.menu.isCollapse
    },
    menuCollapseStyle() {
      return this.isMenuCollapse ? { marginLeft: '65px' } : !this.isUnderMobile() ? { marginLeft: '150px' } : { marginLeft: '0px' }
    }
  },
  watch: {
    // 如果值改变后，同步到 drawer 的状态
    value() {
      this.drawerVisible = this.value

      if (this.drawerVisible && this.isEmptyObject(this.systemInfo.ui_commit)) {
        // 弹窗后，加载UI版本
        this.loadUiVersion()
      }

      // 自动聚焦在输入框，提升交互体验
      if (this.drawerVisible) {
        this.$nextTick(() => {
          this.$refs['searchTextInput'].focus()
        })
      }
    }
  },
  created() {
    // 初始化 drawer 的状态
    this.drawerVisible = this.value
  },
  methods: {
    /**
     * 更改 v-model 值
     *
     * @param {boolean} visible 是否可视
     */
    emitInputEvent(visible) {
      this.$emit('input', visible)
    },
    /**
     * 某一菜单
     *
     * @param {string} menuKey new_menu.js 的 menuKey
     * @returns {object} 菜单元素
     */
    menuItem(menuKey) {
      let menuItem = menuItems.find(item => item.menuKey === menuKey)

      if (this.isEmptyObject(menuItem)) {
        console.error('Can not find menuItem : ' + menuKey)
      }

      return menuItem
    },
    /**
     * 关闭
     */
    _onClosed() {
      this.emitInputEvent(false)
    },
    /**
     * 跳转后关闭窗口
     *
     * @param {string} uri URL
     */
    routerToAfterClosed(uri) {
      this._onClosed()
      this.$router.push(uri)
    },
    /**
     * 加载UI的版本信息
     */
    loadUiVersion() {
      let url = new URL(window.location.href)

      this.$http.get(url.origin + '/version.json?i=' + new Date().getTime() / 1000).then(resp => {
        let info = resp.data
        this.systemInfo.ui_commit = info.gitCommitId
        this.systemInfo.ui_version = info.gitBranchName
      })
    },
    /**
     * 加载后台版本信息
     */
    loadApiVersion() {
      systemApi.getInfo().then(response => {
        this.systemInfo.api_commit = response.data.commit
        this.systemInfo.api_version = response.data.version
        this.systemInfo.browser_description = platform.description
      })
    },
    isUnderMobile() {
      if (nativeMsgUtil.isUnderMobile()) return true
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.all-functions {
  // margin-left: 150px;

  ::v-deep .el-drawer__header {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .close-button {
    font-size: 18px;
    font-weight: bold;
  }

  .toolbar {
    padding: 0px 15px;
    margin-bottom: 15px;
    display: flex;

    .leftside {
      flex: 1; /* 左边内容自适应 */
      margin-right: 10px;
    }

    .rightside {
      ::v-deep .lc-ico-theme:before {
        vertical-align: bottom; /* 避免图标底部白边 */
      }

      .el-button + span.mobile-flex-item {
        margin-left: 10px;
      }
    }
  }

  $screen-md-min: 992px;
  @media (max-width: $screen-md-min) {
    .toolbar {
      .leftside {
        margin-right: 0px;
      }
      .rightside {
        display: flex;
        flex-direction: column;
        margin-top: 10px;

        .el-button {
          width: 100%;
        }

        .el-button + .el-button {
          margin-left: 0;
          margin-top: 5px;
        }

        .el-button + span.mobile-flex-item {
          margin-top: 5px;
        }
      }

      display: block;
    }
  }
}
</style>
